import script from "./FunctionModuleComp.vue?vue&type=script&setup=true&lang=js"
export * from "./FunctionModuleComp.vue?vue&type=script&setup=true&lang=js"

import "./FunctionModuleComp.vue?vue&type=style&index=0&id=18528d1d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18528d1d"]])

export default __exports__